export default {
  searchDocumentsTile: {
    title: 'Formulaires et guides',
    text: 'Trouvez tous les formulaires et guides concernant vos produits.',
    search: 'Chercher',
  },
};
